export default __webpack_public_path__ + "static/company-2-238d5282fd7c50951352ceaf3b33cc17.png";